export default "__VITE_ASSET__Wal9Xw1k__"